import * as React from 'react';

import './core-cards.css'
import { parseDynamicHtml } from '../../../../misc/tools';
/*
EXAMPLE

<div style={{
				width: '1500px',
				height: '500px',
				position: 'absolute',
				left: '300px',
				top: '300px'
			}}>
				<CoreCards cards={[
					{
						img: process.env.PUBLIC_URL + '/assets/sample.jpg',
						htmlContent: `
					<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}class="default-text">
						<strong>Lorem Ipsum</strong> is simply dummy text of the printing and 
						typesetting industry. Lorem Ipsum has been the 
						industry's standard dummy text ever since the 1500s,
						when an unknown printer took a galley of type and 
						scrambled it to make a type specimen book. It has 
						survived not only five centuries, but also the leap 
						into electronic typesetting, remaining essentially 
						unchanged. It was popularised in the 1960s with the 
						release of Letraset sheets containing Lorem Ipsum 
						passages, and more recently with desktop publishing
						software like Aldus PageMaker including versions of 
						Lorem Ipsum.
					</p>
					`
					},
					{
						img: process.env.PUBLIC_URL + '/assets/sample.jpg',
						htmlContent: `
					<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}class="default-text">
						<strong>Lorem Ipsum</strong> is simply dummy text of the printing and 
						typesetting industry. Lorem Ipsum has been the 
						industry's standard dummy text ever since the 1500s,
						when an unknown printer took a galley of type and 
						scrambled it to make a type specimen book. It has 
						survived not only five centuries, but also the leap 
						into electronic typesetting, remaining essentially 
						unchanged. It was popularised in the 1960s with the 
						release of Letraset sheets containing Lorem Ipsum 
						passages, and more recently with desktop publishing
						software like Aldus PageMaker including versions of 
						Lorem Ipsum.
					</p>
					`
					}
				]}></CoreCards>
			</div>


*/

const CoreCards = (props: CoreCardsConfig) => {
  return (
    <div className='core-cards-container'>
      {props.cards.map((card: CoreSingleCardConfig, indx: number) => {
        return (
          <div className='core-cards-container-single-card'>
            <div className='core-cards-container-left-side'>
              <img src={card.img}/>
            </div>
            <div className='core-cards-container-right-side'>
              <div className='core-cards-container-right-side-inner' dangerouslySetInnerHTML={{ __html: parseDynamicHtml(card.htmlContent)}}></div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default CoreCards;

export class CoreCardsConfig {
  cards: CoreSingleCardConfig[];
}

export class CoreSingleCardConfig {
  img: string;
  htmlContent: string;
}